import React from 'react';
import Select from 'react-select';
import { theme } from '../../theme';

const darkStyles = {
    control: (provided, state) => ({
        ...provided,
        background: theme.dark,
        borderColor: state.isFocused ? theme.primary : theme.secondary,
        color: theme.text,
        boxShadow: 'none',
        '&:hover': { borderColor: state.isFocused ? theme.primary : theme.secondaryHover },
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? theme.bg : theme.surface2,
        color: theme.text,
        cursor: 'pointer',
        '&:active': { backgroundColor: theme.border },
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: theme.primary,
    }),
    multiValueLabel: (provided) => ({ ...provided, color: theme.text }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: theme.text,
        '&:hover': { backgroundColor: theme.primaryHover, color: theme.text },
    }),
    input: (provided) => ({ ...provided, color: theme.text }),
    placeholder: (provided) => ({ ...provided, color: theme.textDisabled }),
    singleValue: (provided) => ({ ...provided, color: theme.text }),
    menu: (provided) => ({ ...provided, backgroundColor: theme.surface2, border: `1px solid ${theme.secondary}` }),
    menuList: (provided) => ({ ...provided, maxHeight: 220 }),
};

export { darkStyles };

export function MultiSelect({ options, value, onChange, placeholder = 'Seleccionar...', isMulti = true, disabled }) {
    const allSelected = Array.isArray(options) && options.length > 0 && (value || []).length === options.length;
    return (
        <Select
            isMulti={isMulti}
            options={options}
            value={(value || []).map((v) => options.find((o) => o.value === v)).filter(Boolean)}
            onChange={(sel) => onChange(isMulti ? (sel || []).map((o) => o.value) : (sel ? sel.value : ''))}
            placeholder={placeholder}
            styles={darkStyles}
            isDisabled={disabled}
            isSearchable={!allSelected}
            onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
            theme={(themeObj) => ({
                ...themeObj,
                colors: { ...themeObj.colors, primary: theme.primary },
            })}
        />
    );
}

export default MultiSelect;
